import { Article } from '../../../shared/models/article';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PaginationService} from '../../../shared/services/pagination.service';

@Component({
  selector: 'app-special-products',
  templateUrl: './special-products.component.html',
  styleUrls: ['./special-products.component.scss']
})
export class SpecialProductsComponent implements OnInit {
  counter: number;
  @Input() products: Article[];
  @Input() cantpages: number;
  @Input() page: number;
  @Input() loading: boolean;

  @Output() previous: EventEmitter<any> = new EventEmitter();
  @Output() nextPage: EventEmitter<any> = new EventEmitter();

  constructor(private paginateService: PaginationService) {
  }

  paginate: any = {};

  ngOnInit() {
    this.counter = 1;
  }

  increment = () => this.counter++;

  decrement() {
    if (this.counter > 1) {
      this.counter--;
    }
  }

  lastPage = (): boolean => {
    const p = this.page + 1;
    return p > this.cantpages;
  }

  prev = () => this.previous.emit(null);
  next = () => this.nextPage.emit(null);
}
